<template>
	<path
		id="Vector"
		d="M14.4468 1.95631C12.7343 0.496936 10.1874 0.759436 8.61552 2.38131L7.9999 3.01569L7.38427 2.38131C5.81552 0.759436 3.26552 0.496936 1.55302 1.95631C-0.40948 3.63131 -0.512605 6.63756 1.24365 8.45319L7.29052 14.6969C7.68115 15.1001 8.31552 15.1001 8.70615 14.6969L14.753 8.45319C16.5124 6.63756 16.4093 3.63131 14.4468 1.95631Z"
		fill="#E2E2E2"
	/>
</template>
